import { FC } from 'react';

import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { IColumnLayoutProps } from '~modules/columns/ModuleColumns';

const ColumnLayout2: FC<IColumnLayoutProps> = props => {
  const { data, parentType, parentContext, fieldName, siblingsLength, canMove, stable, columnsClasses } = props;
  return (
    <div className="row px-0 flex-wrap">
      <div className="col col-12 col-xl-12">
        <div className="row flex-wrap">
          <div className={columnsClasses[0]}>
            <DraggableModuleContainer
              parentIsStable={stable}
              index={0}
              entityId={data[0]}
              parentContext={parentContext}
              parentType={parentType}
              fieldName={fieldName}
              siblingsLength={siblingsLength}
              canMove={Boolean(canMove)}
              containerClassName={{ 'u-full-height': true, relative: true }}
            />
          </div>
          <div className={columnsClasses[1]}>
            <DraggableModuleContainer
              parentIsStable={stable}
              index={1}
              entityId={data[1]}
              parentContext={parentContext}
              parentType={parentType}
              fieldName={fieldName}
              siblingsLength={siblingsLength}
              canMove={Boolean(canMove)}
              containerClassName={{ 'u-full-height': true, relative: true }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColumnLayout2;
